import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Employees")
], -1)
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "row align-items-center mt-4" }
const _hoisted_15 = { class: "col p-0" }
const _hoisted_16 = { class: "col ms-4" }
const _hoisted_17 = { class: "col-auto" }
const _hoisted_18 = { class: "form-check d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-1",
  for: "checkbox1"
}, "Hide Disabled", -1)
const _hoisted_20 = { class: "col-auto" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = {
  key: 0,
  class: "spinner-border ms-3 mt-4"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "px-0 py-2" }
const _hoisted_27 = { class: "card-body d-flex flex-row align-items-center hover-shadow-soft" }
const _hoisted_28 = { class: "form-check ms-2 me-3" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "circle",
  style: {"background":"#f4f4f4"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-user fa-xs",
    style: {"color":"#7a7a7a"}
  })
], -1)
const _hoisted_31 = { class: "d-flex flex-column me-auto" }
const _hoisted_32 = { class: "ms-3 mb-1" }
const _hoisted_33 = { class: "ms-3 smallText" }
const _hoisted_34 = {
  class: "ms-4 me-2 smallText",
  style: {"text-align":"right"}
}
const _hoisted_35 = {
  class: "dropdown dropdown-menu shadow-3-strong",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]

import { useRouter } from "vue-router";
import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
  query,
} from "firebase/firestore";
import { Organisation, ValidationType } from "@/model/organisation";
import { computed, onMounted, onUnmounted, ref, Ref, watch } from "vue";
import TableView from "@/components/TableView.vue";
import firebase from "firebase/compat";
import { Employee, EmployeeStatus } from "@/model/employee";
import Unsubscribe = firebase.Unsubscribe;
import { EmployeeMapper } from "@/model/mapper/employee-mapper";
import CreateEmployeeModal from "@/views/organisations/employees/CreateEmployeeModal.vue";
import ImportEmployeesModal from "@/views/organisations/employees/ImportEmployeesModal.vue";
import EditEmployeeModal from "@/views/organisations/employees/EditEmployeeModal.vue";
import { OrganisationMapper } from "@/model/mapper/organisation-mapper";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import { ApiService } from "@/api-service";
import { getFunctions } from "firebase/functions";
import { EmailUtils } from "@/utilties/email-utils";
import StatsOverviewRow from "@/views/organisations/employees/StatsOverviewRow.vue";
import ExportEmployeesModal from "@/views/organisations/employees/ExportEmployeesModal.vue";

enum FilterType {
  all = "All",
  enabled = "Available",
  active = "Active",
  invited = "Invited",
  disabled = "Disabled",
}


const __default__ = {
  name: "EmployeeList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();

let organisation: Ref<Organisation | null> = ref(null);
let loadingOrganisation: Ref<boolean> = ref(true);

let employees: Ref<Employee[]> = ref([]);
let loadingEmployees: Ref<boolean> = ref(true);

let organisationSubscription: Unsubscribe | null = null;
let employeeSubscription: Unsubscribe | null = null;

let editingEmployee: Ref<Employee | null> = ref(null);

let isShowingImportEmployeesModal: Ref<boolean> = ref(false);
let isShowingExportEmployeesModal: Ref<boolean> = ref(false);
let isShowingCreateEmployeeModal: Ref<boolean> = ref(false);
let isShowingEditEmployeeModal: Ref<boolean> = ref(false);
let isShowingEmployeeEnabledModal: Ref<boolean> = ref(false);
let isShowingEmailInviteModal: Ref<boolean> = ref(false);
let isShowingBulkEmailInviteModal: Ref<boolean> = ref(false);

let isLoadingSendInvitation: Ref<boolean> = ref(false);
let isLoadingEnableEmployee: Ref<boolean> = ref(false);

let selectedEmployees: Ref<Employee[]> = ref([]);

let selectedFilterType: Ref<FilterType> = ref(FilterType.all);
let filterTypeOptions: Ref<FilterType[]> = ref([
  FilterType.all,
  FilterType.enabled,
  FilterType.invited,
  FilterType.active,
  FilterType.disabled,
]);
let hideDisabled: Ref<boolean> = ref(true);

const loading = computed<boolean>(
  () => loadingOrganisation.value || loadingEmployees.value
);

const filteredEmployees = computed(() => {
  let filteredEmployees = employees.value;

  if (hideDisabled.value) {
    filteredEmployees = filteredEmployees.filter((employee) => {
      return employee.status().status != EmployeeStatus.disabled;
    });
  }

  if (selectedFilterType.value !== FilterType.all) {
    filteredEmployees = filteredEmployees.filter((employee) => {
      const status = employee.status().status;
      if (selectedFilterType.value === FilterType.enabled) {
        return status === EmployeeStatus.enabled;
      } else if (selectedFilterType.value === FilterType.invited) {
        return status === EmployeeStatus.invited;
      } else if (selectedFilterType.value === FilterType.active) {
        return status === EmployeeStatus.active;
      } else if (selectedFilterType.value === FilterType.disabled) {
        return status === EmployeeStatus.disabled;
      }
      return false;
    });
  }

  return filteredEmployees;
});

const db = getFirestore();

const apiService = new ApiService(getFunctions());

async function getOrganisation(organisationId: string) {
  organisationSubscription = onSnapshot(
    doc(db, "organisations", organisationId),
    (doc) => {
      let data = doc.data();
      if (data) {
        organisation.value = OrganisationMapper.toOrganisation(doc.id, data);
      } else {
        console.log("Failed to retrieve organisation. Document data null");
      }
      loadingOrganisation.value = false;
    },
    (error) => {
      console.log("Failed to query organisation", error);
      loadingOrganisation.value = false;
    }
  );
}

async function getEmployees(organisationId: string) {
  const q = query(collection(db, `organisations/${organisationId}/employees`));
  employeeSubscription = onSnapshot(
    q,
    (querySnapshot) => {
      employees.value = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return EmployeeMapper.toEmployee(doc.id, data);
      });
      loadingEmployees.value = false;
    },
    (error) => {
      console.log("Failed to query employees", error);
      loadingEmployees.value = false;
    }
  );
}

function toggleInviteEmployeeModal(visible: boolean, employee?: Employee) {
  editingEmployee.value = employee ?? null;
  isShowingEmailInviteModal.value = visible;
}

function toggleBulkInviteEmployeeModal(visible: boolean) {
  isShowingBulkEmailInviteModal.value = visible;
}

function toggleCreateEmployeeModal(visible: boolean) {
  isShowingCreateEmployeeModal.value = visible;
}

function toggleImportEmployeesModal(visible: boolean) {
  isShowingImportEmployeesModal.value = visible;
}

function toggleExportEmployeesModal(visible: boolean) {
  isShowingExportEmployeesModal.value = visible;
}

function toggleEditEmployeeModal(visible: boolean, employee?: Employee) {
  editingEmployee.value = employee ?? null;
  isShowingEditEmployeeModal.value = visible;
}

function toggleEmployeeEnabledModal(visible: boolean, employee?: Employee) {
  editingEmployee.value = employee ?? null;
  isShowingEmployeeEnabledModal.value = visible;
}

async function inviteEmployees(employees: Employee[]) {
  if (organisation.value == null) {
    console.log("Failed to invite employees, organisation id null");
    isShowingEmailInviteModal.value = false;
    isShowingBulkEmailInviteModal.value = false;
    return;
  }

  isLoadingSendInvitation.value = true;
  await apiService.inviteEmployees(
    organisation.value!.id,
    organisation.value!.name,
    employees
      .filter((employee) => {
        return EmailUtils.sendEmailAllowed(organisation.value, employee);
      })
      .map((employee) => {
        let emailAddress = employee.emailAddress;
        if (emailAddress == null || emailAddress == "") {
          if (organisation.value?.validation.type == ValidationType.email) {
            emailAddress = employee.emailAddress;
          }
        }
        return {
          employeeId: employee.id,
          emailAddress: emailAddress!,
          firstName: employee.firstName,
        };
      })
  );
  isLoadingSendInvitation.value = false;
  isShowingEmailInviteModal.value = false;
  isShowingBulkEmailInviteModal.value = false;
}

async function toggleEmployeeEnabled(employee: Employee) {
  if (organisation.value == null) {
    console.log("Failed to edit employee isActive state, organisation id null");
    isShowingEmployeeEnabledModal.value = false;
    return;
  }
  isLoadingEnableEmployee.value = true;
  await apiService.editEmployees(organisation.value!.id, [
    {
      employeeId: employee.id,
      isActive: !employee.isEnabled,
    },
  ]);
  isLoadingEnableEmployee.value = false;
  isShowingEmployeeEnabledModal.value = false;
  editingEmployee.value = null;
}

function selectAll() {
  if (
    selectedEmployees.value.length > 0 &&
    selectedEmployees.value.length == filteredEmployees.value.length
  ) {
    selectedEmployees.value = [];
  } else {
    selectedEmployees.value = filteredEmployees.value;
  }
}

const emailableEmployees = computed(() => {
  return selectedEmployees.value.filter((employee) => {
    return EmailUtils.sendEmailAllowed(organisation.value, employee);
  });
});

function goToEmployee(employee: Employee) {
  router.push({
    name: `employeeDetail`,
    params: { employeeId: employee.id },
  });
}

const areAllSelected = computed<boolean>(() => {
  return (
    selectedEmployees.value.length > 0 &&
    selectedEmployees.value.length == filteredEmployees.value.length
  );
});

// Watcher to clear selectedEmployees when selectedFilterType changes
watch(selectedFilterType, (newVal, oldVal) => {
  selectedEmployees.value = [];
});

onMounted(() => {
  let organisationUrl = router.currentRoute.value.params[
    "organisationId"
  ] as string;

  getOrganisation(organisationUrl).catch((error) => {
    console.log("Failed to get organisation", error);
  });
  getEmployees(organisationUrl).catch((error) => {
    console.log("Failed to get employees", error);
  });

  editingEmployee.value = null;

  isShowingEditEmployeeModal.value = false;
  isShowingEmployeeEnabledModal.value = false;
  isShowingEmailInviteModal.value = false;
  isShowingBulkEmailInviteModal.value = false;
  isShowingCreateEmployeeModal.value = false;
  isShowingImportEmployeesModal.value = false;
  isShowingExportEmployeesModal.value = false;

  isLoadingSendInvitation.value = false;
  isLoadingEnableEmployee.value = false;
});

onUnmounted(() => {
  if (organisationSubscription != null) {
    organisationSubscription();
  }
  if (employeeSubscription != null) {
    employeeSubscription();
  }
  isLoadingSendInvitation.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_unref(emailableEmployees).length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-primary btn-lg btn-floating me-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleBulkInviteEmployeeModal(true))),
                    title: "Email"
                  }, _hoisted_7))
                : _createCommentVNode("", true),
              (_unref(selectedEmployees).length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-outline-primary btn-lg btn-floating me-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleExportEmployeesModal(true))),
                    title: "Export CSV"
                  }, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary btn-lg btn-floating me-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleImportEmployeesModal(true))),
                title: "Import CSV"
              }, _hoisted_11),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-lg btn-floating me-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleCreateEmployeeModal(true))),
                title: "Add Employee"
              }, _hoisted_13)
            ])
          ])
        ])
      ]),
      _createVNode(StatsOverviewRow, {
        employees: _unref(employees),
        class: "mt-4"
      }, null, 8, ["employees"]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", {
            class: _normalizeClass(["btn btn-link normal-case ps-3", {
            disabled: _unref(loading) || _unref(filteredEmployees).length == 0,
          }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (selectAll()))
          }, _toDisplayString(_unref(areAllSelected) ? "Clear All" : "Select All"), 3)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", null, _toDisplayString(_unref(filteredEmployees).length) + " Results", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(hideDisabled) ? (hideDisabled).value = $event : hideDisabled = $event)),
              id: "checkbox1",
              class: "form-check-input",
              type: "checkbox",
              onChange: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, null, 544), [
              [_vModelCheckbox, _unref(hideDisabled)]
            ]),
            _hoisted_19
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass(["form-select", { disabled: _unref(loading) }]),
            id: "filter",
            required: "",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(selectedFilterType) ? (selectedFilterType).value = $event : selectedFilterType = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterTypeOptions), (filterType) => {
              return (_openBlock(), _createElementBlock("option", {
                value: filterType,
                key: filterType
              }, _toDisplayString(filterType), 9, _hoisted_21))
            }), 128))
          ], 2), [
            [_vModelSelect, _unref(selectedFilterType)]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(TableView, { borderless: true }, {
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredEmployees), (employee) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: employee,
                      onClick: ($event: any) => (goToEmployee(employee))
                    }, [
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card clickable", {
                    disabled:
                      employee.status().status == _unref(EmployeeStatus).disabled,
                  }])
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "form-check-input",
                                id: "checkbox",
                                value: employee,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(selectedEmployees) ? (selectedEmployees).value = $event : selectedEmployees = $event)),
                                onChange: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                              }, null, 40, _hoisted_29), [
                                [_vModelCheckbox, _unref(selectedEmployees)]
                              ])
                            ]),
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(employee.firstName) + " " + _toDisplayString(employee.lastName), 1),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(employee.id), 1)
                            ]),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(employee.status().message), 1),
                            _createElementVNode("i", {
                              class: "fas fa-ellipsis-v me-2 clickable btn-overflow",
                              id: "dropdownMenuButton1",
                              onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false"
                            }),
                            _createElementVNode("ul", _hoisted_35, [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _withModifiers(($event: any) => (toggleEditEmployeeModal(true, employee)), ["stop"])
                                }, "Edit Employee", 8, _hoisted_36)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: _normalizeClass(["dropdown-item", {
                            disabled: !_unref(EmailUtils).sendEmailAllowed(
                              _unref(organisation),
                              employee
                            ),
                          }]),
                                  onClick: _withModifiers(($event: any) => (
                            toggleInviteEmployeeModal(true, employee)
                          ), ["stop"])
                                }, "Send Invite Email", 10, _hoisted_37)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: _normalizeClass(["dropdown-item", { 'text-danger': employee.isEnabled }]),
                                  onClick: _withModifiers(($event: any) => (
                            toggleEmployeeEnabledModal(true, employee)
                          ), ["stop"])
                                }, _toDisplayString(employee.isEnabled
                              ? "Disable Employee"
                              : "Enable Employee"), 11, _hoisted_38)
                              ])
                            ])
                          ])
                        ], 2)
                      ])
                    ], 8, _hoisted_25))
                  }), 128))
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    (_unref(organisation))
      ? (_openBlock(), _createBlock(CreateEmployeeModal, {
          key: 0,
          "is-visible": _unref(isShowingCreateEmployeeModal),
          onHideModal: _cache[13] || (_cache[13] = ($event: any) => (toggleCreateEmployeeModal(false))),
          "validation-type": _unref(organisation)?.validation.type,
          organisation: _unref(organisation)
        }, null, 8, ["is-visible", "validation-type", "organisation"]))
      : _createCommentVNode("", true),
    (_unref(organisation))
      ? (_openBlock(), _createBlock(ImportEmployeesModal, {
          key: 1,
          "existing-employees": _unref(employees),
          "is-visible": _unref(isShowingImportEmployeesModal),
          onHideModal: _cache[14] || (_cache[14] = ($event: any) => (toggleImportEmployeesModal(false))),
          "validation-type": _unref(organisation)?.validation.type,
          "organisation-id": _unref(organisation)?.id
        }, null, 8, ["existing-employees", "is-visible", "validation-type", "organisation-id"]))
      : _createCommentVNode("", true),
    _createVNode(ExportEmployeesModal, {
      "is-visible": _unref(isShowingExportEmployeesModal),
      employees: _unref(selectedEmployees),
      onHideModal: _cache[15] || (_cache[15] = ($event: any) => (toggleExportEmployeesModal(false)))
    }, null, 8, ["is-visible", "employees"]),
    (_unref(organisation))
      ? (_openBlock(), _createBlock(EditEmployeeModal, {
          key: 2,
          "is-visible": _unref(isShowingEditEmployeeModal),
          onHideModal: _cache[16] || (_cache[16] = ($event: any) => (toggleEditEmployeeModal(false))),
          "validation-type": _unref(organisation)?.validation.type,
          "organisation-id": _unref(organisation)?.id,
          employee: _unref(editingEmployee)
        }, null, 8, ["is-visible", "validation-type", "organisation-id", "employee"]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmationModal, {
      "cancel-button-text": "Cancel",
      "confirm-button-text": "Send",
      "is-visible": _unref(isShowingEmailInviteModal),
      loading: _unref(isLoadingSendInvitation),
      title: "Confirm Email",
      message: 
      'Are you sure you want to send an invite to ' +
      _unref(editingEmployee)?.emailAddress +
      '?'
    ,
      onConfirm: _cache[17] || (_cache[17] = ($event: any) => (inviteEmployees([_unref(editingEmployee)]))),
      onCancel: _cache[18] || (_cache[18] = ($event: any) => (toggleInviteEmployeeModal(false, null))),
      onHideModal: _cache[19] || (_cache[19] = ($event: any) => (toggleInviteEmployeeModal(false, null)))
    }, null, 8, ["is-visible", "loading", "message"]),
    _createVNode(ConfirmationModal, {
      "cancel-button-text": "Cancel",
      "confirm-button-text": "Send",
      "is-visible": _unref(isShowingBulkEmailInviteModal),
      loading: _unref(isLoadingSendInvitation),
      title: "Confirm Email",
      message: 
      'Are you sure you want to send an invite to ' +
      _unref(emailableEmployees).length +
      ' employee(s)?'
    ,
      "message-subtitle": "Only users who are not already active, and have a valid email address will be emailed.",
      onConfirm: _cache[20] || (_cache[20] = ($event: any) => (inviteEmployees(_unref(emailableEmployees)))),
      onCancel: _cache[21] || (_cache[21] = ($event: any) => (toggleBulkInviteEmployeeModal(false))),
      onHideModal: _cache[22] || (_cache[22] = ($event: any) => (toggleBulkInviteEmployeeModal(false)))
    }, null, 8, ["is-visible", "loading", "message"]),
    _createVNode(ConfirmationModal, {
      "cancel-button-text": "Cancel",
      "confirm-button-text": _unref(editingEmployee)?.isEnabled ? 'Disable' : 'Enable',
      "is-visible": _unref(isShowingEmployeeEnabledModal),
      loading: _unref(isLoadingEnableEmployee),
      title: 
      _unref(editingEmployee)?.isEnabled
        ? 'Confirm Disable Employee'
        : 'Confirm Enable Employee'
    ,
      message: 
      'Are you sure you want to ' +
      (_unref(editingEmployee)?.isEnabled ? 'disable ' : 'enable ') +
      _unref(editingEmployee)?.friendlyName() +
      '?'
    ,
      onConfirm: _cache[23] || (_cache[23] = ($event: any) => (toggleEmployeeEnabled(_unref(editingEmployee)))),
      onCancel: _cache[24] || (_cache[24] = ($event: any) => (toggleEmployeeEnabledModal(false))),
      onHideModal: _cache[25] || (_cache[25] = ($event: any) => (toggleEmployeeEnabledModal(false)))
    }, null, 8, ["confirm-button-text", "is-visible", "loading", "title", "message"])
  ], 64))
}
}

})